import Text from '@Text';
import React from 'react';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const FormHeader = ({ text }) => {
  const textExperimentName = useGetExperimentName({
    componentName: 'Text',
  });

  return (
    <Text variant="header" experimentName={textExperimentName}>
      {text}
    </Text>
  );
};

export default FormHeader;
